import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HelpPage from './Help';
import HomePage from './Home';

function App() {
  console.log(process.env.REACT_APP_API_URL);
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/help" element={<HelpPage />} />
      </Routes>
    </Router>
  );
}

export default App;